

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { AdminEarningsSetup } from "../../components/AdminEarningsSetup";


export const AdminEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Earnings"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/departments/list" },
        { text: "Payroll Earnings", navigateTo: "/company/departments/setup" }
      ]}
      mainContents={<AdminEarningsSetup />}
    />
  );
};
